import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Icon } from '../../common/components/Utilities';
import PeopleLayout from '../layout/PeopleLayout';
import DataTable from '../../common/components/DataTable';
import LargeUserPill from '../../common/components/LargeUserPill';

function NewStartersPage(props) {
  return <PeopleLayout {...props} content={<NewStartersShow {...props} />} />;
}

function NewStartersShow() {
  const renderRow = (user) => {
    let start = <Icon icon="times text-danger" append="fa-fw" size="2x" />;
    let squad = <Icon icon="times text-danger" append="fa-fw" size="2x" />;

    if (user.start_date) {
      start = moment(user.start_date).format('dddd D MMMM');
    }

    if ('squads' in user && user.squads.length) {
      squad = user.squads[0].name;
    }

    return (
      <tr>
        <td><LargeUserPill user={user} /></td>

        <td style={{ verticalAlign: 'middle' }}>{start}</td>
        <td style={{ verticalAlign: 'middle' }}>{squad}</td>

        <td style={{ verticalAlign: 'middle', width: '100px' }}>
          <Icon icon={user.job ? 'check text-success' : 'times text-danger'} append="fa-fw" size="2x" />
        </td>

        <td style={{ verticalAlign: 'middle', width: '100px' }}>
          <Icon icon={user.manager ? 'check text-success' : 'times text-danger'} append="fa-fw" size="2x" />
        </td>
        <td style={{ verticalAlign: 'middle', width: '100px' }}>
          <SlackCheck user={user} />
        </td>
        <td style={{ verticalAlign: 'middle', width: '100px' }}>
          <JumpcloudCheck user={user} />
        </td>
        <td style={{ verticalAlign: 'middle', width: '100px' }}>
          <ContactCheck user={user} />
        </td>
        <td style={{ verticalAlign: 'middle', width: '100px' }}>
          <EmergencyCheck user={user} />
        </td>
      </tr>
    );
  };

  return <DataTable url="/resource/users" title="New Starters" filters={{ not_started: 1 }} columns={['Person', 'Start', 'Squad', 'Role', 'Lead', 'Slack', 'Jumpcloud', 'Contact', 'Emergency']} renderRow={renderRow} />;
}

function SlackCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-slack`}
    />
  );
}

function JumpcloudCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-jumpcloud`}
    />
  );
}

function ContactCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-contact`}
    />
  );
}

function EmergencyCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-emergency`}
    />
  );
}

function EndpointCheck({ user, endpoint }) {
  const [isOK, setIsOK] = useState(null);
  const [loading, setLoading] = useState(false);
  const checkEndpoint = async () => {
    setLoading(true);

    try {
      const response = await Axios.get(endpoint);
      setIsOK(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { checkEndpoint(); }, [user]);

  if (loading) {
    return <Icon icon="spinner" append="fa-fw fa-spin" size="2x" />;
  }

  return <Icon icon={isOK ? 'check text-success' : 'times text-danger'} append="fa-fw" size="2x" />;
}

export default NewStartersPage;
